import { useState } from 'react';
import { connect } from 'react-redux';
import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import classnames from 'classnames';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import Tooltip from '@material-ui/core/Tooltip';

import styles from './UserSettings.module.css';
import { onChangeUserSettings } from '../../../ac/onChangeUserSettings';

const UserSettingsComponent = ({ layers, userSettings, onChangeUserSettings }) => {
    const [ open, setOpen ] = useState(false);
    // Черновик правок: настройки применяются по «Готово», а не по каждому клику —
    // иначе панель перестраивается под курсором, пока пользователь ещё выбирает
    const [ hidden, setHidden ] = useState([]);
    const openDialog = () => {
        setHidden(userSettings.hiddenLayerGroups);
        setOpen(true);
    };
    const toggleGroup = groupId => setHidden(prev => prev.includes(groupId)
        ? prev.filter(id => id !== groupId)
        : [ ...prev, groupId ]
    );
    const apply = () => {
        onChangeUserSettings({ ...userSettings, hiddenLayerGroups: hidden });
        setOpen(false);
    };

    return (
        <>
            <Tooltip title={t`Настройки`}>
                <IconButton
                    className={styles.settingsButton}
                    onClick={openDialog}
                    size='small'
                >
                    <SettingsOutlinedIcon fontSize='small' />
                </IconButton>
            </Tooltip>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                maxWidth='xs'
                fullWidth
                PaperProps={{ className: styles.paper }}
            >
                <div className={styles.head}>{t`Настройки`}</div>
                <div className={styles.section}>{t`Группы слоёв, видимые в левой панели`}</div>
                <div className={styles.groupsGrid}>
                    {layers.map(({ id, label }) => (
                        <div
                            key={id}
                            className={styles.groupRow}
                        >
                            <label htmlFor={`layerGroup_${id}`}>{i18n._(label)}</label>
                            <label className={styles.switch}>
                                <input
                                    type='checkbox'
                                    id={`layerGroup_${id}`}
                                    checked={!hidden.includes(id)}
                                    onChange={() => toggleGroup(id)}
                                />
                                <span className={classnames(styles.sliderRound, styles.slider)} />
                            </label>
                        </div>
                    ))}
                </div>
                <div className={styles.actions}>
                    <Button
                        variant='contained'
                        size='small'
                        color='default'
                        onClick={() => setHidden([])}
                        disabled={!hidden.length}
                    >{t`Показать все`}</Button>
                    <Button
                        variant='contained'
                        size='small'
                        color='default'
                        onClick={() => setOpen(false)}
                    >{t`Отмена`}</Button>
                    <Button
                        variant='contained'
                        size='small'
                        color='primary'
                        onClick={apply}
                    >{t`Готово`}</Button>
                </div>
            </Dialog>
        </>
    );
};
const mapStateToProps = ({ map: { layers }, loggedUser: { userSettings } }) => ({
    layers,
    userSettings,
});

export const UserSettings = connect(mapStateToProps, { onChangeUserSettings })(UserSettingsComponent);
